import {applyMiddleware, compose, createStore} from 'redux';

import thunk from 'redux-thunk';
import logger from 'redux-logger';

import {AUTH_LOG_OUT, AUTH_SET_TOKEN} from '../ducks/auth';
import {USER_SET_PROFILE} from '../ducks/user';
import {CART_SET} from '../ducks/cart';

import tabSync from '../middlewares/tabSync';
import gtmAnalytics from '../middlewares/analytics/gtm';
import { getGtmId } from '../utils/analytics';
import ravenMiddleware from '../middlewares/raven';

import rootReducer from './rootReducer';

const middleware = [];

if (process.env.SENTRY_LOGGER === 'true') {
  middleware.push(ravenMiddleware);
}

middleware.push(thunk);

if (process.env.CLIENT) {
  middleware.push(tabSync([AUTH_LOG_OUT, AUTH_SET_TOKEN, USER_SET_PROFILE, CART_SET]));

  const gtmId = getGtmId();

  if (gtmId) {
    middleware.push(gtmAnalytics);
  }

  if (process.env.REDUX_LOGGER === 'true') {
    middleware.push(logger);
  }
}

export default function configureStore(initialState) {
  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(...middleware),
      process.env.CLIENT && window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : f => f
    )
  );

  if (module.hot) {
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./store/configureStore.js